import React from "react";
import DisplayCompanyInfo from "./DisplayCompanyInfo";
import { getValue } from "../CommonUtils";
import { useSelector, useDispatch } from "react-redux";
import { EditCompanyProfileInfo, ResetEditCompanyProfile } from "../../../store/actions/Settings/EditCompanyInfo";
import { GetCustomerUserandCompanyProfileData } from "../../../store/actions/Settings/CustomerUser&CompanyProfileData";
import { usePermissions } from "../../Hook";
import { UserAdditionalInfo } from "../../../store/actions/UserAdditionalInfo";

const initialCompanyInfo = {
  companyName: "",
  email: "",
  contactPerson: "",
  industry: "",
  contactNumber: "",
};

const compInfo = [
  {
    title: "Company name",
    value: null,
    name: "companyName",
    type: "text",
    isRequired: true,
  },
  {
    title: "Industry",
    value: null,
    name: "industry",
    type: "text",
  },
  {
    title: "Email address",
    value: null,
    name: "email",
    type: "text",
    isRequired: true,
  },
  {
    title: "Contact number",
    value: null,
    name: "contactNumber",
    type: "number",
  },
  {
    title: "Contact person",
    value: null,
    name: "contactPerson",
    type: "text",
  },
];

const initailModal = {
  modalName: null,
  edit: false,
};

function CompanyInfo(props) {
  const { title } = props;
  const dispatch = useDispatch();
  const { loggedInUser } = usePermissions();

  const [companyInfo, setCompanyInfo] = React.useState(initialCompanyInfo);
  const [editAbleModal, setEditAbleModal] = React.useState(initailModal);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [saveInfo, setSaveInfo] = React.useState(false);
  const [displaycompanyInfo, setDisplayCompanyInfo] = React.useState(compInfo);

  const CompanyProfileData = useSelector(
    (state) => state.CustomerUserandCompanyProfileData.customerUserandCompanyProfileData
  );

  const editCompanyInfo = useSelector((state) => state.EditCompanyInfo.editCompanyInfo);

  const handleInputChange = (fieldName, value) => {
    setCompanyInfo((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const hanldeEdit = (editableModal) => {
    setEditAbleModal({
      modalName: editableModal,
      edit: true,
    });
  };

  const handleSave = () => {
    handleSaveInfo();
  };

  const handleCancel = (modalName) => {
    setEditAbleModal({
      modalName,
      edit: false,
    });
  };

  const handleSaveInfo = () => {
    setSaveInfo(true);

    if (companyInfo.companyName != "" && companyInfo.email) {
      setOpenAlert(false);
      dispatch(
        EditCompanyProfileInfo({
          companyProfileData: companyInfo,
          customerId: loggedInUser?.userId,
        })
      );
    } else {
      setOpenAlert(true);
    }
  };

  React.useEffect(() => {
    let currentUser = {};
    currentUser = JSON.parse(localStorage.getItem("loggedInUser"));

    const getProfileDataRequest = `customerUser/${currentUser?.userId}`;
    if (editCompanyInfo?.ok) {
      setEditAbleModal({
        modalName: null,
        edit: false,
      });
      dispatch(UserAdditionalInfo(`customer/${currentUser?.customerId}/info`));
      dispatch(
        GetCustomerUserandCompanyProfileData({
          request: getProfileDataRequest,
        })
      );
      dispatch(ResetEditCompanyProfile({}));
    }
  }, [editCompanyInfo]);

  React.useEffect(() => {
    if (CompanyProfileData?.ok) {
      setCompanyInfo({
        companyName: getValue(CompanyProfileData?.payload?.customer?.companyName),
        email: getValue(CompanyProfileData?.payload?.customer?.contactEmail),
        contactNumber: getValue(CompanyProfileData?.payload?.customer?.contactNumber),
        industry: getValue(CompanyProfileData?.payload?.customer?.industry),
        contactPerson: getValue(CompanyProfileData?.payload?.customer?.contactPerson),
      });

      compInfo[0].value = getValue(CompanyProfileData?.payload?.customer?.companyName);
      compInfo[1].value = getValue(CompanyProfileData?.payload?.customer?.industry);
      compInfo[2].value = getValue(CompanyProfileData?.payload?.customer?.contactEmail);
      compInfo[3].value = getValue(CompanyProfileData?.payload?.customer?.contactNumber);
      compInfo[4].value = getValue(CompanyProfileData?.payload?.customer?.contactPerson);
      setDisplayCompanyInfo(compInfo);
    }
  }, [CompanyProfileData]);

  return (
    <DisplayCompanyInfo
      data={displaycompanyInfo}
      title={title}
      fieldsData={companyInfo}
      hanldeEdit={hanldeEdit}
      editAbleModal={editAbleModal}
      handleInputChange={handleInputChange}
      handleCancel={handleCancel}
      handleSave={handleSave}
      icon
      bgColor="#F2FFFB"
      iconColor="#00C0AF"
      open={openAlert}
      setOpenAlert={setOpenAlert}
      editCompanyInfo={editCompanyInfo}
      saveInfo={saveInfo}
    />
  );
}

export default CompanyInfo;
